import { Dropdown as AntDropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { produce } from "immer";
import React, { useState } from "react";
//import { Input as AntInput } from 'antd';
//import { Form } from 'antd';
//export { Form };
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import styled from "styled-components";
//export { Form } from "antd";
export { Checkbox } from "antd";

export const Form = styled.div`
	.error__label-temporary {
		color: #f5222d;
	}
	.input__phone-container {
		display: flex;
		align-items: center;
		position: relative;
	}
	.input__select {
		height: 34px;
		position: absolute;
		bottom: 5px;
		left: 2px;
		border: none;
		border-radius: 20px;
		font-size: 16px;
		width: 60px;
		background-color: transparent;
	}
`;

/*
const FormItem = Form.Item;

const InputField = ({placeholder, label, value, validator, onChange, name, errorMessage}) => {
	const isValid = typeof value === 'undefined' || validator(value);
	return (
		<FormItem
		  label={label}
		  hasFeedback={errorMessage}
		  validateStatus={isValid ? null : "error" }
		>
			  <AntInput placeholder={placeholder} value={value} onChange={onChange} name={name} />
	    </FormItem>
	);
}
*/

const FormItem = ({ children, label, hasFeedback, validateStatus }) => {
	return (
		<div>
			<Label>{label}</Label>
			{children}
			{hasFeedback && validateStatus === "error" ? (
				<Feedback className="input-feedback">{hasFeedback}</Feedback>
			) : null}
		</div>
	);
};

export const Input = ({
	placeholder,
	hidden,
	label,
	value,
	validator,
	onChange,
	name,
	errorMessage,
	postInput,
}) => {
	const isValid = typeof value === "undefined" || validator(value);
	const onChangeWrapper = (onChange) => (ev) => {
		if (!postInput) return onChange(ev);
		const newEvent = produce(ev, (e) => {
			e.target.value = postInput(e.target.value);
		});
		return onChange(newEvent);
	};
	if (hidden === true) return null;
	return (
		<FormItem
			label={label}
			hasFeedback={errorMessage}
			validateStatus={isValid ? null : "error"}
		>
			<TextInput
				type="text"
				placeholder={placeholder || label}
				value={value}
				onChange={onChangeWrapper(onChange)}
				name={name}
			/>
		</FormItem>
	);
};

export const Password = ({
	placeholder,
	label,
	value,
	validator,
	onChange,
	name,
	errorMessage,
}) => {
	const [show, toggleShow] = useState(false);
	const isValid = typeof value === "undefined" || validator(value);
	const onClick = () => toggleShow((s) => !s);
	return (
		<FormItem
			label={label}
			hasFeedback={errorMessage}
			validateStatus={isValid ? null : "error"}
		>
			<FieldGroup>
				<TextInput
					type={show ? "text" : "password"}
					placeholder={placeholder || label}
					value={value}
					onChange={onChange}
					name={name}
				/>
				<div onClick={onClick}>
					{show ? <EyeInvisibleOutlined /> : <EyeOutlined />}
				</div>
			</FieldGroup>
		</FormItem>
	);
};

const menu = (
	<Menu>
		<Menu.Item>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="http://www.alipay.com/"
			>
				1st menu item
			</a>
		</Menu.Item>
		<Menu.Item>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="http://www.taobao.com/"
			>
				2nd menu item
			</a>
		</Menu.Item>
		<Menu.Item>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href="http://www.tmall.com/"
			>
				3rd menu item
			</a>
		</Menu.Item>
		<Menu.Item danger>a danger item</Menu.Item>
	</Menu>
);

export const DropDown = ({ name, items, onClick, title }) => {
	const handleClick = (onClick, item) => (ev) => {
		ev.preventDefault();
		onClick({ target: { name, value: item } });
	};
	const menus = items.map((item) => (
		<Menu.Item key={item}>
			<a
				target="_blank"
				rel="noopener noreferrer"
				onClick={handleClick(onClick, item)}
			>
				{item}
			</a>
		</Menu.Item>
	));
	const menu = <Menu>{menus}</Menu>;

	return (
		<AntDropdown overlay={menu}>
			<a
				className="ant-dropdown-link"
				onClick={(e) => e.preventDefault()}
			>
				{title} <DownOutlined />
			</a>
		</AntDropdown>
	);
};

const TextInput = styled.input`
	background-color: transparent;
	border: none;
	border-bottom: 1px solid #a2a2a2;
	width: 100%;

	&:-webkit-autofill,
	&:-webkit-autofill:hover,
	&:-webkit-autofill:focus {
		-webkit-text-fill-color: #fff !important;
		-webkit-box-shadow: 0 0 0px 0 0 0px 1000px #394ba4 inset !important;
		transition: background-color 5000s ease-in-out 0s;
	}

	@media screen and (min-width: 768px) {
		&:-webkit-autofill,
		&:-webkit-autofill:hover,
		&:-webkit-autofill:focus {
			-webkit-text-fill-color: black !important;
			-webkit-box-shadow: 0 0 0px 0 0 0px 1000px #394ba4 inset !important;
			transition: background-color 5000s ease-in-out 0s;
		}
	}
`;

const Label = styled.label`
	color: #a2a2a2;
	font-weight: 600;
	font-size: 16px;
	margin-bottom: 1rem;
	display: block;
`;

const Feedback = styled.div`
	color: #ffcccb;
	font-size: 12px;
	font-weight: 600;
`;

const FieldGroup = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
